import "./NursingCareProviderInKfarSabaWithinFiveHours.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import AboutMissionPreview from "./sections/AboutMissionPreview";
import SpecializedServicesGrid from "./sections/SpecializedServicesGrid";
import FaqSection from "./sections/FaqSection";
import CtaFooterSection from "./sections/CtaFooterSection";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareProviderInKfarSabaWithinFiveHoursPage() {
  return <div>
      <Header />
      <HeroBanner />
      <AboutMissionPreview />
      <SpecializedServicesGrid />
      <FaqSection />
      <CtaFooterSection />
      <Footer />
    </div>;
}